import http from "@/plugins/http";

export const state = {
	cancellationHistoryList: {}
};

export const getters = {
	cancellationHistoryList: state => {
		return state.cancellationHistoryList;
	}
};

export const mutations = {
	SET_CANCELLATION_HISTORY (state, data) {
		state.cancellationHistoryList = data;
	}
};

export const actions = {
	async getCancellationHistory ({ commit, dispatch, rootState }) {
		dispatch("processLoader/setProcessActive", {}, { root: true });
		try {
			let logs = await http.get(
				`visp/GetCancellationHistory/${rootState.service.available.radiusServiceId}`
			);
			commit("SET_CANCELLATION_HISTORY", logs.data.data.entries);
			dispatch("processLoader/setProcessInactive", {}, { root: true });
		} catch (e) {
			dispatch(
				"httpResponse/setHttpResponse",
				{ text: e, color: "error" },
				{ root: true }
			);
			dispatch("processLoader/setProcessInactive", {}, { root: true });
			return Promise.reject(e);
		}
	}
};
